<template>
  <div class="wrapper">
    <div v-if="list.length == 0">暂无数据</div>
    <Collapse v-else v-model="value1">
      <Panel v-for="(i, n) in list" :key="n.toString()">
        {{ i.name }}
        <p slot="content">{{ i.content }}</p>
      </Panel>
    </Collapse>
  </div>
</template>
<script>
  export default {
    props: {
      list: {
        type: Array,
        default: () => []
      }
    },
    data() {
      return {
        value1: '0'
      }
    },
    components: {},
    computed: {},
    mounted() {
    },
    methods: {
    }
  }
</script>
<style scoped lang="less">
  .wrapper {
    width: 80%;
    margin: 0 auto;
    .item {
      font-size: 15px;
      margin-top: 20px;
    }
  }
</style>
